import { app } from '../../../app';
import { groupFromDto } from './group.dto';

class AccountsResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getUserAccount(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        return this.$http.get(url).then(({data}) => data);
    }

    deleteUserAccount(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        return this.$http.delete(url).then(({data}) => data);
    }

    deleteUserAccounts(companyId, accountIds) {
        return this
            .$http({
                method: 'DELETE',
                url: `app/rest/v2/company/${companyId}/accounts`,
                data: accountIds,
                headers: {'Content-Type': 'application/json'},
            })
            .then(({data}) => data)
    }

    getAllGroupsForUserAccount(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}/groups`;
        const params = {type: 'assigned'};
        return this.$http.get(url, {params}).then(({data}) => data)
            .then((items) => items.map((item) => ({...item, group: groupFromDto(item.group)})))
    }

    getAllGroupsUserCanBeAssignedTo(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}/groups`;
        const params = {type: 'unassigned'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    assignUserToGroups(companyId, accountId, groupIds) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}/groups`;
        const params = {action: 'assign'};
        return this.$http.post(url, groupIds, {params}).then(({data}) => data);
    }

    removeUserFromGroups(companyId, accountId, groupIds) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}/groups`;
        const params = {action: 'removeuser'};
        return this.$http.post(url, groupIds, {params}).then(({data}) => data);
    }

    getProfileAttributes(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}/profiles`;
        return this.$http.get(url).then(({data}) => data)
            .then((data) => ({...data, profile: data.profile || {}}))
    }

    updateProfileAttributes(companyId, accountId, profile) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}/profiles`;
        return this.$http.put(url, profile).then(({data}) => data);
    }

    updateCustomAttributes(companyId, accountId, attribs) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}/customattributes/update`;
        return this.$http.put(url, attribs).then(({data}) => data);
    }

    setAsMainProfileOfEmployee(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}/profiles`;
        const params = {action: 'setmainprofile'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    changeOwner(companyId, accountId, newOwner) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        const params = {action: 'changeuser'};
        return this.$http.put(url, newOwner, {params}).then(({data}) => data);
    }

    removeAccountOwner(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        const params = {action: 'removeuser'};
        return this.$http.put(url, null, {params}).then(({data}) => data);
    }

    verifyAccount(companyId, accountId, accountOwner) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        const params = {action: 'verifyuser'};
        return this.$http.put(url, accountOwner, {params}).then(({data}) => data);
    }

    assignAccountVerificationEmail(companyId, accountId, emailAddress) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        const params = {action: 'assignverification'};
        return this.$http.put(url, emailAddress, {params}).then(({data}) => data);
    }

    removeAccountVerificationEmail(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        const params = {action: 'removeverification'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    resendVerificationEmail(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        const params = {action: 'resendverification'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    sendVerificationEmail(companyId, accountId, emailAddress) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        const params = {action: 'sendverification'};
        return this.$http.post(url, emailAddress, {params}).then(({data}) => data);
    }

    invalidateVerificationData(companyId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${accountId}`;
        const params = {action: 'invalidateverification'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    addNewUserAccount(companyId, username) {
        const url = `app/rest/v2/company/${companyId}/accounts`;
        const params = {username};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getAccountsByUsername(companyId, groupId, username) {
        const url = `app/rest/v2/company/${companyId}/accounts`;
        const params = {group: groupId, username};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    resendVerificationEmailForSelectedAccounts(companyId, accountIds, resendactive) {
        const url = `app/rest/v2/company/${companyId}/accounts`;
        const params = {action: 'resendverification', resendactive};
        return this.$http.post(url, accountIds, {params}).then(({data}) => data);
    }

	resendVerificationEmailForGroup(companyId, groupId, resendactive) {
        const url = `app/rest/v2/company/${companyId}/accounts`;
        const params = {action: 'resendverificationingroup', resendactive, groupId};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }
    
    resendVerificationEmailForDirectoryAccounts(companyId, resendactive) {
        const url = `app/rest/v2/company/${companyId}/accounts`;
        const params = {action: 'resendverificationtoall', resendactive};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }
    
    uploadUsers(companyId, verificationTypes, allowChangeOwner, file, to = '') {
        const url = `app/rest/v2/company/${companyId}/accounts`;
        const formData = new FormData();
        formData.append('file', file);
        const params = {action: 'import', to, verificationTypes, allowChangeOwner};
        const headers = {'Content-Type': undefined};
        return this.$http.post(url, formData, {params, headers}).then(({data}) => data);
    }

    removeUsersFromGroup(companyId, groupId, accountIds) {
        const url = `app/rest/v2/company/${companyId}/accounts`;
        const params = {action: 'remove', from: groupId};
        return this.$http.post(url, accountIds, {params}).then(({data}) => data);
    }

    copyUsersToGroup(companyId, groupIds, accountIds) {
        const url = `app/rest/v2/company/${companyId}/accounts`;
        const data = {groups: groupIds, userAccounts: accountIds};
        const params = {action: 'copy'};
        return this.$http.post(url, data, {params}).then(({data}) => data);
    }

    moveUsersToGroup(companyId, fromGroupId, toGroupId, accountIds) {
        const url = `app/rest/v2/company/${companyId}/accounts`;
        const params = {action: 'move', from: fromGroupId, to: toGroupId};
        return this.$http.post(url, accountIds, {params}).then(({data}) => data);
    }

    bulkCopyCompanyUserAccount(companyId, fromUserId, toUser, selectedAccountIds) {
        const url = `app/rest/v2/company/${companyId}/users/${fromUserId}/bulk`;
        const params = {action: 'copy', type:'account'};
        return this.$http.post(url, {selectedAccountIds, companyUser:toUser}, {params}).then(({data}) => data);
    }

    bulkMoveCompanyUserAccount(companyId, fromUserId, toUser, selectedAccountIds) {
        const url = `app/rest/v2/company/${companyId}/users/${fromUserId}/bulk`;
        const params = {action: 'move', type:'account'};
        return this.$http.post(url, {selectedAccountIds, companyUser:toUser}, {params}).then(({data}) => data);
    }

    bulkCopyCompanySharedAccount(companyId, fromUserId, toUser, selectedAccountIds) {
        const url = `app/rest/v2/company/${companyId}/users/${fromUserId}/bulk`;
        const params = {action: 'copy', type:'shared'};
        return this.$http.post(url, {selectedAccountIds, companyUser:toUser}, {params}).then(({data}) => data);
    }

    bulkMoveCompanySharedAccount(companyId, fromUserId, toUser, selectedAccountIds) {
        const url = `app/rest/v2/company/${companyId}/users/${fromUserId}/bulk`;
        const params = {action: 'move', type:'shared'};
        return this.$http.post(url, {selectedAccountIds, companyUser:toUser}, {params}).then(({data}) => data);
    }

    setPasswordForAccount(companyId, appId, accountId, password) {
        const url = `app/rest/v2/company/${companyId}/accounts/${appId}/${accountId}/setpassword`;
        const params = {password};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getComputerLoginCodeForAccount(companyId, appId, accountId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${appId}/${accountId}/getcomputerlogincode`;
        return this.$http.get(url).then(({data}) => data);
    }
}

app.service('AccountsResource', AccountsResource);



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/accounts-resource.service.js